export default "__VITE_PUBLIC_ASSET__7395009e__"